// extracted by mini-css-extract-plugin
export default {"brand":"ProjectSecretaryBrand_brand__0YgI0","mark":"ProjectSecretaryBrand_mark__IMHMw","text":"ProjectSecretaryBrand_text__Q7e7z"};